import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import Text from '@amzn/meridian/text';
import Column from '@amzn/meridian/column';
import { Loading } from 'src/common/loaders/Loading';
import { SmediumLoader } from 'src/common/loaders/SmediumLoader';
import { Link } from 'src/common/styled';
import { RetailRoutes, useRetailRedirectUrls } from 'src/utils/links';
import { sendAuthMessage, sendOpenLinkMessage } from 'src/utils/messages';
import { useAnalyticsContext } from 'src/common/metrics';
import { AuthStatus, ParzivalGatewayAuthErrorType } from 'src/utils/auth';
export const InvalidAuthPage = ({ errorType }) => {
    const [bundle, isBundleLoading] = useBundle('pages.invalidAuthPage');
    const rumClient = useAnalyticsContext();
    const redirectUrls = useRetailRedirectUrls([RetailRoutes.DETAIL_PAGE]);
    const handleAuthRefresh = () => {
        const authStatus = errorType === ParzivalGatewayAuthErrorType.EXPIRED_AUTH ? AuthStatus.REFRESH_TOKEN : AuthStatus.AUTHENTICATE;
        sendAuthMessage(rumClient, authStatus);
    };
    const openExternalLink = (e) => {
        e.preventDefault();
        const url = e.currentTarget.href;
        // This is intentionally left out from OffRamp because we cannot make a call to the report API without auth.
        sendOpenLinkMessage(rumClient, url);
    };
    useEffect(() => {
        rumClient.recordEvent(`INVALID_AUTH_PAGE_${ParzivalGatewayAuthErrorType[errorType]}`, {});
        if (errorType === ParzivalGatewayAuthErrorType.INCORRECT_AUTH) {
            rumClient.recordError(new Error('Incorrect authentication'));
        }
        handleAuthRefresh();
    }, []);
    if (isBundleLoading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(Column, { spacingInset: "400", spacing: "450", minHeight: "100vh", alignmentHorizontal: "center", alignmentVertical: "center", "data-testid": "expired-auth-component", children: [_jsx(SmediumLoader, {}), _jsxs(Column, { spacing: "300", children: [_jsx(Text, { alignment: "center", "data-testid": "refresh-message", children: bundle.getMessage('refreshMessage') }), _jsx(Text, { alignment: "center", children: bundle.formatMessage('retry', {
                            retryLink: (chunk) => (_jsx(Link, { role: "button", underline: true, onClick: handleAuthRefresh, "data-testid": "retry-link", children: chunk }, "retry-link")),
                            amazonLink: (chunk) => (_jsx(Link, { underline: true, href: redirectUrls.DETAIL_PAGE, onClick: openExternalLink, "data-testid": "amazon-link", children: chunk }, "amazon-link")),
                        }) })] })] }));
};
